import { AvatarProps } from "@/types/component";

import "./index.scss";

import React from "react";

const Avatar: React.FC<AvatarProps> = ({
  alt,
  // children,
  color = "default",
  height,
  src,
  variant,
  width,
}) => {
  const colorClass = color !== "default" ? `color-${color}` : "color-default";
  const sizeStyle =
    width != null && height != null
      ? { width: `${width}px`, height: `${height}px` }
      : undefined;

  return (
    <div
      className={`avatar ${variant ? variant : ""} ${colorClass}`}
      title={alt}
      style={sizeStyle}
    >
      {src ? (
        <img alt={alt} src={src} />
      ) : (
        <svg
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="72" height="72" rx="36" fill="#FFEFF0" />
          <rect x="16" y="16" width="40" height="40" rx="20" fill="#FFEFF0" />
          <path
            d="M14.885 72H57.115C58.7947 72 60.1121 71.6512 61.0673 70.9535C62.0224 70.2558 62.5 69.2978 62.5 68.0793C62.5 66.1928 61.886 64.1982 60.658 62.0955C59.4299 59.9929 57.6663 58.0228 55.3672 56.1854C53.0684 54.348 50.2867 52.8544 47.022 51.7048C43.7575 50.5552 40.0783 49.9803 35.9843 49.9803C31.9114 49.9803 28.2427 50.5552 24.978 51.7048C21.7134 52.8544 18.9264 54.348 16.6171 56.1854C14.3077 58.0228 12.5442 59.9929 11.3265 62.0955C10.1088 64.1982 9.5 66.1928 9.5 68.0793C9.5 69.2978 9.97762 70.2558 10.9329 70.9535C11.8881 71.6512 13.2055 72 14.885 72ZM36.0158 44.7041C38.2622 44.7041 40.3406 44.1292 42.251 42.9796C44.1615 41.83 45.6994 40.2727 46.8646 38.3075C48.0298 36.3424 48.6124 34.1316 48.6124 31.6752C48.6124 29.258 48.0298 27.0915 46.8646 25.1754C45.6994 23.2594 44.1615 21.7512 42.251 20.6507C40.3406 19.5502 38.2622 19 36.0158 19C33.7694 19 31.691 19.5601 29.7805 20.6802C27.87 21.8003 26.3322 23.3233 25.167 25.2492C24.0018 27.175 23.4192 29.3366 23.4192 31.7341C23.4192 34.1709 24.0018 36.3669 25.167 38.3222C26.3322 40.2776 27.87 41.83 29.7805 42.9796C31.691 44.1292 33.7694 44.7041 36.0158 44.7041Z"
            fill="url(#paint0_linear_40000998_166260)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_40000998_166260"
              x1="36"
              y1="12.1857"
              x2="35.8864"
              y2="111.293"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#E7212B" />
              <stop offset="1" stopColor="#E7212B" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </div>
  );
};

export default Avatar;
